<template>
  <section>
    <el-table
      v-if="isLoading || !responses.length"
      v-loading="isLoading"
      :data="responses"
      empty-text="Вы еше не оставили заявку на перевозку"
    />
    <section v-if="responses.length && !isLoading" class="middle-section">
      <el-row v-if="!disabled">
        <el-col :span="22" :offset="1">
          <p>
            Чтобы внести измнение или отменить заявку, нажмите на текст заявки
          </p>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22" :offset="1">
          <p>
            <b> {{ isDriverRole ? 'Вы д' : 'Д' }}обавили в заявку: </b>
          </p>
        </el-col>
      </el-row>
      <loader-wrapper :loading="loading">
        <section v-for="(res, i) in responses" :key="res.id" class="response">
          <div class="mb-5" @click="onClick(res)">
            <el-row>
              <el-col :span="1">{{ i + 1 }}.</el-col>
              <el-col :span="8">
                {{ isDriverRole ? 'ВОДИТЕЛЬ:' : 'ПЕРЕВОЗЧИК:' }}
              </el-col>
              <el-col :span="15">
                <b>{{ getName(res.driver) }}</b>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" :offset="1">АВТО и ПРИЦЕП:</el-col>
              <el-col :span="15">
                <b>
                  {{ res.auto.state_numbers || 'Нет данных' }}
                  /
                  {{ res.auto.state_numbers_trailer || 'Нет данных' }}
                </b>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" :offset="1">ВАША ЦЕНА:</el-col>
              <el-col :span="15" class="dp_green">
                <template v-if="type !== 'harvest'">
                  {{ res.price_from_storage_driver | getPrice }}
                  <span v-if="type === 'harvest_or_delivery'">(П),</span>
                </template>
                <template v-if="type !== 'delivery'">
                  {{ res.price_from_field_driver | getPrice }}
                  <span v-if="type === 'harvest_or_delivery'">(У)</span>
                </template>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" :offset="1">СТАТУС:</el-col>
              <el-col
                :span="15"
                :class="checkApproveStatus(res) === 1 ? 'dp_green' : 'dp_red'"
              >
                <b>{{ statuses[checkApproveStatus(res)] }}</b>
              </el-col>
            </el-row>
          </div>
          <el-row v-if="!disabled">
            <el-col :offset="9" :span="15">
              <el-button
                type="danger"
                class="mob-btn del-btn"
                :loading="loading"
                @click="deleteAuto(res.bid_id, res.id)"
              >
                Удалить
              </el-button>
            </el-col>
          </el-row>
        </section>
      </loader-wrapper>
    </section>
  </section>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { entryStatuses } from '@/datas/consts'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const Bids = RepositoryFactory.get('bids')

export default {
  name: 'DriverListMobile',
  components: { LoaderWrapper },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: '',
    },
    responses: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statuses: entryStatuses,
      loading: false,
    }
  },
  computed: {
    ...mapGetters('bids', ['getLoading']),
    isLoading() {
      return this.getLoading('Resp')
    },
  },
  methods: {
    ...mapActions('bids', ['fetchHomeBid']),
    ...mapMutations('loadDay', ['deleteResponse']),
    onClick(res) {
      if (!this.disabled) {
        this.$emit('change', res, true)
      }
    },
    getName(driver) {
      const { fio, carrier_name } = driver
      const name = this.isDriverRole ? fio : this.isIP(carrier_name)

      return name || 'Нет данных'
    },
    isIP(name) {
      return name && name.includes('ИП ')
        ? 'ИП ' + this.shortFio(name.substr(3))
        : name
    },
    deleteAuto(bid_id, id) {
      this.$confirm('Вы уверены что хотите удалить заявку?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена',
        type: 'warning',
        customClass: 'before-del',
      })
        .then(() => {
          this.loading = true
          Bids.deleteBidRequest(bid_id, id)
            .then(() => {
              this.deleteResponse(id)
              this.fetchHomeBid({ bid_id, user_type: this.userInfo.user_type })
            })
            .catch(err => this.errHandler(err))
            .finally(() => (this.loading = false))
        })
        .catch(() => {})
    },
  },
}
</script>
